import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const poaoutletApi = api
  .enhanceEndpoints({ addTagTypes: ['POAOutlet'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPOAOutlets: builder.query<(po_aoutlet & po_aprinters)[], string>({
        query: cid => `poaoutlet/${cid}`,
        providesTags: ['POAOutlet']
      }),
      getPOAOutletById: builder.query<po_aoutlet, number>({
        query: id => `poaoutlet/byid/${id}`,
        providesTags: ['POAOutlet']
      }),
      insertPOAOutlet: builder.mutation({
        query: poaoutlet => ({
          url: `poaoutlet/`,
          method: 'POST',
          body: poaoutlet
        }),
        invalidatesTags: ['POAOutlet']
      }),
      updatePOAOutlet: builder.mutation({
        query: poaoutlet => ({
          url: `poaoutlet/`,
          method: 'PUT',
          body: poaoutlet
        }),
        invalidatesTags: ['POAOutlet']
      }),
      deletePOAOutlet: builder.mutation({
        query: poaoutlet => ({
          url: `poaoutlet/${poaoutlet.ol_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['POAOutlet']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPOAOutletsQuery,
  useGetPOAOutletByIdQuery,
  useInsertPOAOutletMutation,
  useUpdatePOAOutletMutation,
  useDeletePOAOutletMutation
} = poaoutletApi;

